<!--  会员流转 -->
<template>
    <div class="box">
        <div class="tab-box">
            <div class="store-box flex-start flex-y-center" v-show="showStoreSelect">
                <div @click="showSelctStoreEvt()" class="region-name-box flex-row flex-between flex-y-center">
                    <div class="name-txt">{{ selectedStore.storeName }}</div>
                    <img class="store-arrow" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-right-arrow.png" alt="">
                </div>
            </div>
            <div class="search">
                <form action="/">
                    <van-search class="search-button" v-model="searchStr" @search="onSearch" @clear="selClear" placeholder="搜索姓名/手机" left-icon="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-07/search.png">
                    </van-search>
                </form>
            </div>
            <div class="date-box  flex-row  flex-between">
                <div class="date">
                    <div class="arrow-box">
                        <div class="arrow-l" @click="handleCalendar('prev')"></div>
                    </div>
                    <div>{{ year }}年{{ month }}月</div>
                    <div class="arrow-box">
                        <div class="arrow-r" @click="handleCalendar('next')"></div>
                    </div>
                </div>
                <div class="update-time">
                    数据更新至:{{ piceData.time || '暂无' }}
                </div>
            </div>
            <div class="change-box">
                <van-dropdown-menu active-color="#37DBE0">
                    <van-dropdown-item v-model="typeVal" :options="typeOpt" @change="onRefresh()"></van-dropdown-item>
                </van-dropdown-menu>
                <van-dropdown-menu active-color="#37DBE0">
                    <van-dropdown-item v-model="employeeName" :options="employeeNameList" @change="onRefresh()"></van-dropdown-item>
                </van-dropdown-menu>
            </div>
            <div class="infoWrapper">
                <div>
                    <label>当月来店:</label>
                    <span>{{ piceData.inStore || 0 }}人</span>
                </div>
                <div>
                    <label>6个月内皮测人数:</label>
                    <span>{{ piceData.inPc || 0 }}人</span>
                </div>
                <div>
                    <label>检测率:</label>
                    <span>{{ piceData.rate || 0 }}</span>
                </div>
            </div>
        </div>
        <div class="table">
            <div class="table-tab  flex flex-x-center">
                <div :class="`tab-item ${tabIndex == 0 ? 'active' : ''}`" @click="clickTab(0)">
                    本月来店已皮测({{ piceData.pcNumber || 0 }})
                </div>
                <div :class="`tab-item item-text ${tabIndex == 1 ? 'active' : ''}`" @click="clickTab(1)">
                    本月来店未皮测({{ piceData.notPcNumber || 0 }})
                </div>
            </div>
            <div class="box-line"></div>
            <div class="list-box">
                <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功">
                    <van-list v-model="loading" :finished="finished" :loading="loading" finished-text="没有更多了" @load="getCustList" :offset="20" :immediate-check="false">
                        <div class="customer-list flex-col" v-for="(item, index) in customerList" :key="index" @click="toDetail(item.custId, item.phone)">
                            <div class="custInfoWrapper">
                                <div class="info">
                                    <div class="info-left">
                                        <img class="touxiang" :src="item.avatar ? item.avatar : 'https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-06/headPortrait.png'" alt="">
                                        <span class="name">{{ item.custName }}</span>
                                        <img v-if="item.cardImageSmallUrl" class="card" :src="item.cardImageSmallUrl" alt="">
                                        <img class="arrow" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-right-arrow.png" alt="">
                                    </div>
                                    <div class="info-right">
                                        <img class="wechat" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-04-02/wechat.png" @click.stop="toOpenWechat(item)" alt="">
                                        <img class="phone" v-if="item.phone" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-04-02/phone.png" @click.stop="toPhone(item)" alt="">
                                    </div>
                                </div>
                                <div>顾问:{{ item.employeeName }}</div>
                                <div>最近来店:{{ item.lastInstoreName }} {{ item.lastOrderDate ? formatDate(item.lastOrderDate, 'yyyy-MM-dd HH:mm:ss') : '' }}</div>
                                <div>当年累计测试:{{ item.ytdPcCnt }}</div>
                                <div>首次皮测:{{ item.firstPcStoreName }} {{ item.firstPcDate ? formatDate(item.firstPcDate, 'yyyy-MM-dd HH:mm:ss') : '' }}</div>
                                <div>最近1次皮测:{{ item.lastPcStoreName }} {{ item.lastPcDate ? formatDate(item.lastPcDate, 'yyyy-MM-dd HH:mm:ss') : '' }}</div>
                            </div>
                        </div>
                    </van-list>
                </van-pull-refresh>
                <van-popup v-model="showSelctStore" round position="bottom">
                    <van-picker show-toolbar ref="storeRef" value-key="storeName" :default-index="defaultIndex" :columns="storeDataList" @cancel="showSelctStore = false" @confirm="confirmSelectStoreEvt" />
                </van-popup>
            </div>
        </div>
    </div>
</template>

<script>
    import request from "@/utils/request";
    import { timeFormatNew, formatDateTime } from "@/utils/util"
    import { findIndexArray } from "@/utils/handleStore"
    import { Toast } from 'vant'
    import { timestampToYestoday } from '@/utils/validate';
    import { openEnterpriseChat } from '@/utils/wxCodeAuth'
    import Picker from '@/components/Picker';
    import { mapState } from 'vuex'
    import { getUserLogin, getRegionStoreList, saveRegionStore } from '@/api/home'

    export default {
        name: "piceDirector",
        inject: ['reload'],
        components: {
            Picker
        },
        data() {
            return {
                tabIndex: 0, // tab栏下标
                searchStr: "",
                checkTypeTab: '0',
                loading: false,
                finished: false,
                refreshing: false,
                page: 1,
                total: 0,
                customerList: [],
                updateTime: timestampToYestoday(),   //更新时间
                postId: 0, // 岗位
                showRegionPopup: false,
                showRegionStorePopup: false,
                regionStoreList: [],//区域门店列表
                regionList: [],//区域列表
                checkedRegion: { id: -1, name: '' },//所选区域
                checkedStore: {  //所选门店
                    name: '',
                    id: -1,
                },
                typeOpt: [
                    { text: '全部', value: 0 },
                    { text: '散客', value: 1 },
                    { text: '疗程客&会员', value: 2 },
                ],
                typeVal: 0,
                year: new Date().getFullYear(),
                month: new Date().getMonth() + 1,
                employeeNameList: [],
                employeeName: "0",
                showSelctStore: false,
                storeDataList: [],
                selectedStore: {},
                piceData: {},
                defaultIndex: 0,
                isPc: 1
            };
        },
        computed: {
            ...mapState({
                regionPostId: (state) => {
                    return state.user.permissions.regionPostId
                },// 区经区总id
            }),
            showStoreSelect() {
                if (this.storeDataList.length == 1) {
                    if (!this.storeDataList[0].children) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return true
                }
            }
        },
        async mounted() {
            await this.getRegion()  //门店列表
            await this.getemployeesList(); //顾问
            await this.getData()  //页面数据
            await this.getCustList()  //顾客数据
        },
        methods: {
            getRegion() {
                const sendData = {
                    id: this.selectedStore.id || ''
                }
                return request({
                    url: 'employeeStore/empStoreList',
                    method: 'get',
                    params: sendData
                }).then(res => {
                    if (res.code === 0) {
                        this.storeDataList = res.data
                        this.selectedStore = this.$route.query.storeName ? this.$route.query : res.data[0]
                    }
                })
            },
            formatDate(date, fmt) {
                return formatDateTime(new Date(date), fmt)
            },
            getData() {
                const sendData = {
                    searchStr: this.searchStr,
                    limit: 10,
                    page: this.page,
                    isPc: this.isPc,
                    time: `${this.year}-${this.month < 10 ? '0' + this.month : this.month}`,
                    id: this.selectedStore.id,
                    empNo: this.employeeName,
                    type: this.typeVal
                }
                return request({
                    url: `/bfpc/quantity`,
                    method: "get",
                    params: sendData
                }).then(res => {
                    if (res.code == 0 && res.data) {
                        this.piceData = res.data
                    }
                })
            },
            getCustList() {
                let params = {
                    searchStr: this.searchStr,
                    limit: 10,
                    page: this.page,
                    isPc: this.isPc,
                    time: `${this.year}-${this.month < 10 ? '0' + this.month : this.month}`,
                    id: this.selectedStore.id,
                    empNo: this.employeeName,
                    type: this.typeVal
                }
                if (this.regionPostId.includes(this.postId)) {
                    params.id = this.checkedRegion.id
                    params.storeId = this.checkedStore.id
                }
                request({
                    url: `/bfpc/details`,
                    method: "get",
                    params: params
                })
                    .then((res) => {
                        this.customerList = this.page == 1 ? res.data.list : this.customerList.concat(res.data.list);
                        this.page += 1;
                        this.total = res.data.total;
                    }).catch((error) => {
                        this.finished = true
                        Toast({ position: 'top', message: error ?? '' })
                    }).finally(() => {
                        this.loading = false;
                        if (this.customerList.length >= this.total) {
                            this.finished = true;
                        }
                    });
            },
            //跳转顾客详情页
            toDetail(custId, phone) {
                if (!custId) return
                this.$router.push({ name: "customerDetail", query: { custId: custId, phone: phone } });
            },

            // tab切换
            clickTab(tabIndex) {
                this.tabIndex = tabIndex
                this.isPc = tabIndex == 0 ? 1 : 2
                this.onRefresh();
            },

            // 查询
            onSearch(e) {
                this.searchStr = e
                this.onRefresh();
            },
            //清除搜索
            selClear() {
                this.searchStr = "";
                this.onRefresh();
            },

            onRefresh() {
                this.page = 1
                // 清空列表数据
                this.finished = false;
                // 重新加载数据
                // 将 loading 设置为 true，表示处于加载状态
                this.loading = true;
                this.customerList = [];
                this.refreshing = false;
                this.getData()
                this.getCustList()
            },
            //打开会话
            toOpenWechat(item) {
                if (item.wxExternalUserid && item.isWxContact == 1)   //是好友有userid，打开会话
                    openEnterpriseChat('', item.wxExternalUserid, '', '')
                else
                    //跳转至绑定客户界面
                    this.$router.push({ name: "toBindingCustomer", query: { custName: item.custName, mobile: item.phone, accountNo: item.custAccountId, pageName: "pireDirector", customerListSearchStr: this.searchStr, customerListisPc: this.isPc } });
            },
            toPhone(item) {
                if (item.phone) {
                    window.location.href = `tel:${item.phone}`
                }
            },

            // 获取员工信息
            getemployeesList() {
                request({
                    url: `/workEmployee/getEmployeeList`,
                    method: "get",
                })
                    .then((res) => {
                        if (res.data.length) {
                            const employeeNameList = res.data.map((item) => {
                                return {
                                    text: item.name,
                                    value: item.id,
                                };
                            });
                            this.employeeNameList = employeeNameList;
                        }
                    })
                    .catch((error) => {
                        Toast({ position: 'top', message: error ?? '' })
                    }).finally(() => {
                    })
            },

            // 三级联动确认
            async confirmSelectStoreEvt(v, s, i) {
                const values = this.$refs.storeRef.getValues();
                if (values.length > 0) {
                    // 从数组中筛选出所有text不为空且id不为0,(全部门店)的项
                    const validItems = values.filter(item => item.storeName != '' && item.id != 0);
                    // 取最后一个有效项
                    const lastValidItem = validItems[validItems.length - 1];
                    if (lastValidItem) {
                        this.selectedStore = lastValidItem;
                        if (lastValidItem.departmentType != 1) {
                            this.$router.replace({
                                name: 'piceRegion'
                            })
                        }
                    }
                    this.page = 1
                    await this.getData()
                    await this.getCustList()
                }
                this.showSelctStore = false;
            },

            // 切换月份
            handleCalendar(handle) {
                this.page = 1;
                const year = this.year;
                const month = this.month;
                this.bookingData = [];
                if (handle === "prev") {
                    let newMonth = month - 1;
                    let newYear = year;
                    if (newMonth < 1) {
                        newYear = year - 1;
                        newMonth = 12;
                    }
                    this.year = newYear
                    this.month = newMonth
                } else {
                    let newMonth = month + 1;
                    let newYear = year;
                    if (newMonth > 12) {
                        newYear = year + 1;
                        newMonth = 1;
                    }
                    this.year = newYear
                    this.month = newMonth
                }
                this.onRefresh();
            },
            showSelctStoreEvt() {
                this.showSelctStore = true;
                this.$nextTick(() => {
                    const indexArray = findIndexArray(this.storeDataList, this.selectedStore.id);
                    if (indexArray.length === 1) {
                        this.defaultIndex = indexArray[0]
                    } else {
                        // 设置选中值
                        this.$refs.storeRef.setIndexes(indexArray);
                    }
                })
            }
        },
    };
</script>

<style scoped lang="less">
    .box {
        height: 100%;
    }

    .custInfoWrapper {
        font-size: 26px;
        color: #798A94;
        border-radius: 30px;
        padding: 30px;

        >div {
            margin: 20px 0;

            &:first-of-type {
                margin: 0;
            }

            &:last-of-type {
                margin: 0;
            }
        }

        .info {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .info-left {
                display: flex;
                align-items: center;

                .touxiang {
                    width: 88px;
                    height: 88px;
                    border-radius: 50%;
                }

                .name {
                    font-size: 34px;
                    color: #333333;
                    margin: 0 20px;
                }

                .card {
                    width: 90px;
                    height: 34px;
                    margin: 0 20px;
                }

                .arrow {
                    width: 15px;
                }
            }

            .info-right {
                display: flex;
                align-items: center;

                .wechat {
                    width: 38px;
                    // height: 30PX;
                    margin-right: 40px;
                }

                .phone {
                    width: 37px;
                    // height: 35PX;
                }
            }
        }
    }

    .infoWrapper {
        display: flex;
        font-size: 26px;
        padding: 0 30px;
        justify-content: space-between;
        background-color: #ffffff;
        margin: 40px 0;

        div {
            >label {
                color: #A0ACB5;
            }
        }
    }

    .tab-box {
        width: 750px;
        background: #ffffff;
    }

    .date-box {
        background-color: #ffffff;

        .date {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            line-height: 92.4px;
            margin: -6px 30px;
            font-size: 30px;
            color: #35434c;
        }

        .arrow-l {
            width: 0;
            height: 0;
            border-top: 10px solid transparent;
            border-right: 10px solid #35434c;
            border-bottom: 10px solid transparent;
            margin-right: 30px;
        }

        .arrow-r {
            width: 0;
            height: 0;
            border-top: 10px solid transparent;
            border-left: 10px solid #35434c;
            border-bottom: 10px solid transparent;
            margin-left: 30px;
        }
    }

    .change-box {
        // height: 80px;
        // width: 200px;
        font-size: 26px;
        display: flex;

        .van-dropdown-menu {
            padding: 0 20px;
        }
    }

    .table-tab {
        display: flex;
        justify-content: space-around;
    }

    .tab-item {
        height: 42px;
        font-size: 30px;
        font-weight: 400;
        color: #a0acb5;
        text-align: center;
        position: relative;
    }


    .tab-item.active {
        color: #35434c;
        font-weight: bold;
    }

    .tab-item.active::after {
        position: absolute;
        bottom: -20px;
        content: "";
        width: 110px;
        height: 4px;
        background: #37dbe0;
        left: 50%;
        transform: translateX(-50%);
    }

    .box-line {
        width: 690px;
        height: 1px;
        background: #d7d7d7;
        margin: 20px 0 0 30px;
        opacity: 0.5;
    }

    .update-time {
        height: 37px;
        font-size: 26px;
        color: #a0acb5;
        line-height: 37px;
        margin: 30px 30px 0 30px;
    }

    .list-box {
        width: 100%;
        height: 100vh;
        justify-content: space-between;
        margin: 0 auto 0;
        position: relative;
        z-index: 1;
        overflow-y: auto;
        padding: 0 0 250px 0;
    }

    .customer-list {
        z-index: 35;
        min-height: 331px;
        border-radius: 30px;
        background-color: rgba(255, 255, 255, 1);
        box-shadow: 0px 2px 26px 0px rgba(2, 2, 2, 0.08);
        width: 690px;
        position: relative;
        margin: 28px auto;
    }

    .customer-list-box {
        width: 632px;
        min-height: 269px;
        margin: 30px 0 30px 30px;
    }

    .customer-outer {
        width: 630px;
        height: 212px;
        margin-left: 2px;
    }

    .customer-group {
        width: 325px;
        height: 212px;
    }

    .customer-info {
        width: 320px;
        height: 88px;
    }

    .head-portrait {
        width: 88px;
        height: 88px;
        border-radius: 45px;
    }

    .cdpTag {
        width: 103px;
        height: 45px;
        position: absolute;
        top: 0;
        left: 0;
    }

    .customer-info-box {
        width: 212px;
        height: 88px;
        margin-left: 30px;
    }

    .customer-main {
        width: 400px;
        height: 48px;
    }

    .name {
        max-width: 260px;
        height: 48px;
        display: inline-block;
        color: rgba(53, 67, 76, 1);
        font-size: 34px;
        line-height: 48px;
        text-align: left;
        overflow: hidden;
        /*溢出的部分隐藏*/
        white-space: nowrap;
        /*文本不换行*/
        text-overflow: ellipsis;
        /*ellipsis:文本溢出显示省略号（...）；clip：不显示省略标记（...），而是简单的裁切*/
    }

    .card-grade {
        height: 34px;
        border-radius: 17px;
        margin-top: 6px;
        margin-left: 20px;
    }

    .txt3 {
        width: 66px;
        height: 30px;
        display: inline-block;
        color: rgba(255, 255, 255, 1);
        font-size: 22px;
        white-space: nowrap;
        line-height: 30px;
        text-align: left;
        margin: 2px 0 0 12px;
    }

    .card-image {
        height: 34px;
        width: 90px;
    }

    .mobile {
        width: 147px;
        height: 37px;
        display: inline-block;
        color: rgba(53, 67, 76, 1);
        font-size: 26px;
        white-space: nowrap;
        line-height: 37px;
        text-align: left;
        margin-top: 6px;
    }

    .membership-box {
        width: 325px;
        height: 37px;
        margin-top: 30px;
    }

    .membership-attributes {
        width: 234px;
        height: 37px;
        display: inline-block;
        color: rgba(121, 138, 148, 1);
        font-size: 26px;
        white-space: nowrap;
        line-height: 37px;
        text-align: left;
    }

    .membership-div {
        padding: 0 5px;
        margin-left: 30px;
        width: 70px;
        height: 34px;
        border-radius: 23px;
        border: 2px solid #2fd0d5;
        color: rgba(47, 208, 213, 1);
        font-size: 22px;
        white-space: nowrap;
        line-height: 34px;
        text-align: center;
    }

    .card-balance {
        width: 234px;
        height: 37px;
        display: inline-block;
        color: rgba(121, 138, 148, 1);
        font-size: 26px;
        white-space: nowrap;
        line-height: 37px;
        text-align: left;
        margin-top: 20px;
    }

    .arrived-store {
        width: 579px;
        height: 37px;
        display: inline-block;
        color: rgba(121, 138, 148, 1);
        font-size: 26px;
        white-space: nowrap;
        line-height: 37px;
        text-align: left;
        margin-top: 20px;
    }

    .brithday {
        z-index: 46;
        height: 148px;
        background: url(https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-06/birthdayTag.png) 0px -40px no-repeat;
        background-size: 235px 188px;
        width: 204px;
        position: absolute;
        left: 486px;
        top: 0;
    }

    .empty-txt {
        font-size: 30px;
        color: #a0acb5;
    }

    .empty-icon {
        width: 280px;
        height: 280px;
        margin-top: 179px;
    }

    .brithday-txt {
        width: 81px;
        height: 73px;
        display: inline-block;
        color: rgba(53, 67, 76, 1);
        font-size: 26px;
        line-height: 37px;
        text-align: left;
        margin: 27px 0 0 121px;
        transform: rotate(35deg);
        -webkit-transform-origin-x: 5px;
    }

    .van-pull-refresh {
        min-height: 100%;
    }

    .store-box {
        padding: 30px 30px 0 30px;
        background-color: #fff;

        .store-arrow {
            width: 16px;
            height: 26px;
            margin-left: 8px;
            margin-top: 3px;
        }

        .region-name-box {
            min-width: 239px;
            height: 58px;
            background: #f5f5f5;
            border-radius: 35px;
            margin-right: 10px;
            padding: 10px 15px 11px 16px;
        }

        .store-name-box {
            min-width: 187px;
            height: 58px;
            background: #f5f5f5;
            border-radius: 35px;
            padding: 10px 15px 11px 16px;
        }

        .name-txt {
            color: #66757f;
            font-size: 26px;
        }
    }

    :deep(.search .van-search) {
        background-color: #fff !important;
        padding: 34px 30px 30px 30px !important;
    }

    :deep(.search .van-icon) {
        font-size: 28px;
    }

    :deep(.search .van-search__content) {
        padding-left: 0 !important;
    }

    :deep(.van-field__left-icon) {
        color: #c8c9cc !important;
        padding: 8px 20px 0 20px !important;
        margin-right: 0 !important;
    }

    :deep(.van-tabs__nav) {
        background-color: #f5f6f7 !important;
    }

    :deep(.van-list__finished-text) {
        height: 280px !important;
    }

    :deep(.van-tab--active) {
        font-weight: 400 !important;
    }

    :deep(.van-field__control) {
        font-size: 28px !important;
    }

    :deep(.van-dropdown-menu__title::after) {
        border-color: transparent transparent #35434c #35434c !important;
        border-top-width: 7px !important;
        border-right-width: 7px !important;
        border-bottom-width: 7px !important;
        border-left-width: 7px !important;
        border-top-style: solid !important;
        border-right-style: solid !important;
        border-bottom-style: solid !important;
        border-left-style: solid !important;
    }

    :deep(.van-dropdown-menu__bar) {
        // background-color: #f5f6f7 !important;
        height: 80px !important;
        box-shadow: none !important;
    }
</style>
